import AvatarComponent from './Avatar.component';

export * from './Avatar.component';
export default AvatarComponent;
